const setupPrimaryNavigation = () => {
	const siteNavigation = document.querySelector('.site-navigation__menu');
	siteNavigation.dataset.sharedIndicator = 'site-navigation';
	siteNavigation.dataset.sharedIndicatorOptions = JSON.stringify({ selectedIndicator: false });

	// Force current menu item to be inert.
	const currentMenuItem = siteNavigation.querySelector('.current-menu-item a')
	if (currentMenuItem) { currentMenuItem.inert = true; }

	const menuItems = siteNavigation.querySelectorAll('.menu-item')
	menuItems.forEach((menuItem, index, items )=> {
		menuItem.addEventListener('click', event => {
			items.forEach(item => item.classList.remove('current-menu-item'));
			menuItem.classList.add('current-menu-item');
		})
	});
}

export { setupPrimaryNavigation };
